import {autoRegister} from "../container";
import {GLOBAL} from "./globals";
import type {Nullable} from "../bootstrap/common/types";

@autoRegister()
export class VisualViewportListener {
    private callbacks: (() => void)[];
    private visualViewport: Nullable<VisualViewport>;

    public constructor() {
        this.callbacks = [];
        this.visualViewport = GLOBAL.visualViewport();
        this.visualViewport?.addEventListener("resize", () => this.applyCallbacks());
    }

    public onResize(callback: () => void): void {
        this.callbacks.push(callback);
    }

    private applyCallbacks(): void {
        this.callbacks.forEach(callback => callback());
    }
}